<template>
<v-container fluid fill-height>
    <v-layout align-left>
        <v-flex xs4 class="pa-1">
            <v-card class="mx-auto" max-width="400">
                <v-sheet class="pa-3 primary">
                    <v-text-field v-model="search" label="Buscar.." dark text solo-inverted hide-details clearable clear-icon="mdi-close-circle-outline"></v-text-field>
                </v-sheet>
                <v-card-text>

                    <v-treeview v-model="tree" :open="open" :items="items" :search="search" active-class="grey lighten-2 indigo--text" :active.sync="active" activatable returnObject>
                        <template v-slot:prepend="{ item, open }">
                            <v-icon v-if="!item.file">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                            <v-icon v-else>{{ files[item.file] }}</v-icon>
                        </template>
                    </v-treeview>

                </v-card-text>
            </v-card>

        </v-flex>
        <v-flex xs8 class="pa-1">

            <v-card class="mx-auto" v-if="active.length>0">
                <v-card-title class="primary white--text">
                    <v-icon small class="white--text">search</v-icon>&nbsp;
                    <span class="subheading">
                        <strong>Vista Previa</strong>
                    </span>
                    {{active}}
                </v-card-title>

                <v-card-text>

                    <br />
                    <div id="app" style="min-height:500px;">

                        <PDFViewer v-bind="{url}" @document-errored="onDocumentErrored">

                        </PDFViewer>

                    </div>
                </v-card-text>
            </v-card>

        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import PDFViewer from '@/components/pdf/PDFViewer.vue'
import {
    request
} from 'http';
import {
    mapState
} from 'vuex'
import axios from "axios";

export default {

    components: {
        PDFViewer,
    },
    created() {
        this.URL = this.$hostname + 's3/';
        this.cargar();
    },

    methods: {
        onDocumentErrored(e) {
            this.documentError = e.text;
        },
        cargar: function () {
          var referencia = this.$local_storage.get('referencia');            
           // var referencia = 'MOLG9106088U1-00002';
            var cliente = this.$local_storage.get('id_cliente');
            if (referencia != null && referencia.trim() != '') {
                var datos = {
                    cliente: cliente,
                    referencia: referencia,
                };
                axios.post(this.URL + 'list_cliente/', datos)
                    .then((res) => {

                        if (typeof res.data !== 'undefined') {
                            console.log(res.data);

                        }
                    })
                    .catch((err) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener los documentos"
                        });
                        console.log(err.response);
                    }).then(() => {
                        this.formUpdated = false;
                    });
            }
        },
    },
    data: () => ({
        fab: false,
        // url: 'https://cdn.filestackcontent.com/wcrjf9qPTCKX',
        url: process.env.VUE_APP_PDF_URL,
        documentError: undefined,
        search: null,
        active: [],
        sel: null,
        open: ["facturas"],
        URL: '',
        files: {
            pdf: "mdi-file-pdf",
            png: "mdi-file-image",
            jpg: "mdi-file-image-outline",
            txt: "mdi-file-document-outline",
            xls: "mdi-file-excel",
            xlsx: "mdi-file-excel",
            docx: "mdi-file-word",
            doc: "mdi-file-word",
            xml: "mdi-file-xml"
        },
        tree: [],
        items: [{
                id: 1,
                name: ".git",
                dir: "/x/y/z"
            },
            {
                id: 2,
                name: "node_modules",
                dir: "/x/y/z"
            },
            {
                id: 3,
                name: "facturas",
                dir: "/x/y/z",
                children: [{
                        id: 4,
                        name: "static",
                        dir: "/x/y/z",
                        children: [{
                            id: 5,
                            name: "logo.png",
                            file: "png",
                            dir: "/x/y/z",
                        }]
                    },

                    {
                        id: 6,
                        name: "favicon.ico",
                        file: "png",
                        dir: "/x/y/z",
                    },
                    {
                        id: 7,
                        name: "index.html",
                        file: "xml",
                        dir: "/x/y/z",
                    }
                ]
            },
        ]
    })
};
</script>

<style scoped>
body {
    margin: 0;
    padding: 0;
    background-color: #606f7b;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #62637a;
}

label.form {
    color: white;
    font-family: Monaco, 'Courier New', Courier, monospace;
    font-weight: bold;
    margin-bottom: 2em;
    display: block;
}

input {
    padding: 0.45em;
    font-size: 1em;
}

.error {
    border: 1px solid red;
    background: pink;
    color: red;
    padding: 0.5em 3em;
    display: inline;
}

a.icon {
    cursor: pointer;
    display: block;
    border: 1px #333 solid;
    background: white;
    color: #333;
    font-weight: bold;
    padding: 0.25em;
    width: 1em;
    height: 1em;
    font-size: 1.5em;
}

.box-shadow {
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08);
}

.overflow-hidden {
    overflow: hidden;
}

@media print {
    body {
        background-color: transparent;
    }

    #app {
        margin: 0;
        padding: 0;
    }
}
</style>
